import type { MiniTortClaimDetailSchema } from '@/services/api/generated/miniTortService';
import type { DetailedMatter } from '@/services/types/client-intake-types';

import { MiniTortAttachments } from './MiniTortAttachments';
import { MiniTortClaimCard } from './MiniTortClaimCard';
import { MiniTortDetailsCard } from './MiniTortDetailsCard';
import { MiniTortTimeline } from './MiniTortTimeline';

interface MiniTortOverviewProps {
  matter: DetailedMatter;
  miniTortClaim: MiniTortClaimDetailSchema;
}

export const MiniTortOverview = ({
  matter,
  miniTortClaim,
}: MiniTortOverviewProps) => {
  return (
    <div className="rounded-lg border border-zinc-200 bg-white overflow-hidden divide-y divide-zinc-200">
      <MiniTortClaimCard
        claimId={miniTortClaim.id}
        className="border-0 rounded-none"
      />
      <MiniTortDetailsCard
        matterId={matter.id}
        claim={miniTortClaim}
        client={matter.clients?.[0]}
        className="border-0 rounded-none"
      />
      <MiniTortAttachments
        matterId={matter.id}
        className="border-0 rounded-none"
      />
      <div>
        <div className="px-5 pt-4 pb-1.5">
          <span className="text-xs font-semibold text-zinc-900">
            Recent Activity
          </span>
        </div>
        <div className="px-5 pb-4">
          <MiniTortTimeline claimId={miniTortClaim.id} />
        </div>
      </div>
    </div>
  );
};
